(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["GN-0029"] && !Shopify.designMode) return;
  try {
    
const grey_dot = "https://cdn.shopify.com/s/files/1/2513/1876/files/GN-0029-DotGrey.png?v=1732102157";
const black_dot = "https://cdn.shopify.com/s/files/1/2513/1876/files/GN-0029-DotBlack.png?v=1732102167";
const grey_arrow = "https://cdn.shopify.com/s/files/1/2513/1876/files/GN-0029-ArrowGrey.png?v=1732102142";
const black_arrow = "https://cdn.shopify.com/s/files/1/2513/1876/files/GN-0029-ArrowBlack.png?v=1732102183";

function setUpSlider(wrapper) {
  const slider = wrapper.querySelector('.gn-0029-slider');
  const slides = wrapper.querySelectorAll('.gn-0029-slider .gn-0029-slide');
  const rightArrow = wrapper.querySelector('.gn-0029-arrow-right');
  const leftArrow = wrapper.querySelector('.gn-0029-arrow-left');
  const dots = wrapper.querySelectorAll('.gn-0029-dots img');

  function computeWidth() {
    const elemWidth = slides[0].clientWidth;
    const sliderWidth = slider.clientWidth;
    const gap = 10;

    return Math.floor(sliderWidth / elemWidth) * (elemWidth + gap);
  }

  let selected_dot = 0;
  slider.addEventListener('scroll', function (e) {
    const img_width = computeWidth();
    const position = Math.ceil(slider.scrollLeft / img_width);

    dots[selected_dot].src = grey_dot;
    dots[position].src = black_dot;
    selected_dot = position;

    if(position === 0) {
      leftArrow.src = grey_arrow;
      rightArrow.src = black_arrow;
    } else if (position === slides.length - 1) {
      leftArrow.src = black_arrow;
      rightArrow.src = grey_arrow;
    } else {
      leftArrow.src = black_arrow;
      rightArrow.src = black_arrow;
    }
  });

  rightArrow.addEventListener('click', function (e) {
    const img_width = computeWidth();
    const position = Math.ceil(slider.scrollLeft / img_width);

    slider.scrollTo((position + 1) * img_width, 0);
  });

  leftArrow.addEventListener('click', function (e) {
    const img_width = computeWidth();
    const position = Math.ceil(slider.scrollLeft / img_width);

    slider.scrollTo((position - 1) * img_width, 0);
  });

  slider.dispatchEvent(new CustomEvent("scroll"));
}

function setUpPopups(slidesWrapper, popupsWrapper) {
  const slides = slidesWrapper.querySelectorAll('.gn-0029-slider .gn-0029-slide');
  const popups = popupsWrapper.querySelectorAll('.gn-0029-popup');
  const overlay = document.querySelector('.gn-0029-popup-overlay');

  overlay.addEventListener('click', (e) => close());

  for(let i = 0; i < popups.length; i++) {
    const image = popups[i].querySelector(".gn-0029-popup-img");
    const videos = popups[i].querySelector(".gn-0029-video-container");
    const videoBtn = popups[i].querySelector(".gn-0029-popup-btn");
    const quitBtn = popups[i].querySelector(".gn-0029-popup-quit");
    const atcBtn = popups[i].querySelector(".gn-0029-atc");
    const inputs = popups[i].querySelectorAll(".gn-0029-checkmark input");

    slides[i].addEventListener("click", () => {
      popups[i].classList.add('active')
      overlay.classList.add('active')
      document.body.classList.add('active');
    });

    //Close
    quitBtn.addEventListener("click", () => close());

    videoBtn.addEventListener('click', (e) => {
      e.preventDefault();
      
      const videoElement = popups[i].querySelector('.gn-0029-video:nth-of-type(1n)');
      const video = popups[i].querySelector('.gn-0029-video:nth-of-type(1n) video');

      if(videoElement && video) {
        videoElement.classList.add('active');

        //Start video
        video.play();
      }

      //Add Active to first video
      image.classList.remove('active');
      videos.classList.add('active');
    })

    atcBtn.addEventListener("click", () => {
      const checkboxes = popups[i].querySelectorAll(".gn-0029-checkmark input");

      // Delay computation variable
      let count = 0;
      for(let i = 0; i <  checkboxes.length; i++) {
        if(checkboxes[i].checked) {
          const id = checkboxes[i].dataset.id;
          setTimeout(() => {
            fetch(`${window.location.origin}/cart/add?id=${id}&quantity=1`)
            .then((response) => {
              fetch(`${window.location.origin}/cart.js`).then(async (response) => {
                const cartContent = await response.json();
                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                  bubbles: true,
                  detail: {
                      cart: cartContent,
                      openMiniCart: true
                    }
                }));

                atcBtn.classList.add('active');

                setTimeout(() => atcBtn.classList.remove('active'), 5000);
              })
              .catch(error => console.error(error));
            })
            .catch((error) => {
                console.error("Error:", error);
            });
          }, 500 * count);
          count++;
        }
      }
    });

    inputs.forEach((input) => input.addEventListener('change', (e) => {
      const product = input.parentElement.parentElement;
      product.classList.toggle('active', input.checked);
    }));
  }
}

const moveVideos = () => {
  let videos = document.querySelectorAll('.gn-0029-video');
  videos.forEach((element, i) => {
    const { index } = element.dataset;
    const target = document.querySelector(`.gn-0029-popup[data-index="${index}"] .gn-0029-bullets`)
    const video = element.querySelector('video');

    element.addEventListener('click', (e) => {
      if(video.paused) {
        video.play();
      } else {
        video.pause();
      }
    })

    target.before(element);
  });

  //Create ID to map bullets
  const popups = document.querySelectorAll('.gn-0029-popup')
  popups.forEach((popup) => {
    const videos = popup.querySelectorAll('.gn-0029-video');
    videos.forEach((video, i) => {
      //Append first and last to video
      if(i === 0) {
        video.classList.add('is-first');
      }

      if(i === (videos.length - 1)) {
        video.classList.add('is-last');
      }

      video.dataset.id = i;
    });
  });
}

const createBullets = () => {
  const popups = document.querySelectorAll('.gn-0029-popup');
  popups.forEach((popup) => {
    const parent = document.querySelector('.gn-0029-videos');
    const videos = popup.querySelectorAll('.gn-0029-video');
    const bullets = popup.querySelector('.gn-0029-bullets');

    videos.forEach((video, index) => {
      const bullet = document.createElement('span');
      bullet.classList.add('gn-0029-bullet');
      bullet.classList.toggle('active', index === 0)

      bullets.append(bullet);
    })
  })
}

const videoControls = () => {
  const update = (button, type = 'next') => {
    const index = parseInt(button.dataset.index);
    const id = parseInt(button.dataset.id);

    const parent = document.querySelector(`.gn-0029-popup[data-index="${index}"]`);
    const videos = parent.querySelectorAll('.gn-0029-videos video');
    const prev = parent.querySelector('.gn-0029-video-prev');
    const next = parent.querySelector('.gn-0029-video-next');

    //Update button
    const targetId = type === 'next' ? id + 1 : id - 1;
    prev.dataset.id = type === 'next' ? id + 1 : id - 1;
    next.dataset.id = type === 'next' ? id + 1 : id - 1;

    //Target
    const oldTarget = parent.querySelector(`.gn-0029-video[data-id="${id}"]`);
    const target = parent.querySelector(`.gn-0029-video[data-id="${targetId}"]`);
    const bullets = parent.querySelectorAll('.gn-0029-bullet');

    //Move to next element
    target.scrollIntoView({ 
      behavior: "smooth", 
      block: "center" 
    });

    //Add Active
    oldTarget.classList.remove('active');
    target.classList.add('active');

    //Video
    stopVideos();

    //Play video
    const video = target.querySelector('video');
    video.play();

    //Bullets
    const bulletId = target.dataset.id;
    if(bullets[bulletId]) {
      bullets.forEach((bullet) => bullet.classList.remove('active'))
      bullets[bulletId].classList.add('active')
    }
  }

  const next = document.querySelectorAll('.gn-0029-video-next');
  next.forEach((button) => {
    button.addEventListener('click', (e) => {
      update(button, 'next');
    })
  })

  const prev = document.querySelectorAll('.gn-0029-video-prev');
  prev.forEach((button) => {
    button.addEventListener('click', (e) => {
      update(button, 'prev');
    })
  });

  const mutes = document.querySelectorAll('.gn-0029-video-mute');
  mutes.forEach((button) => button.addEventListener('click', (e) => {
    button.classList.toggle('active');

    const videos = document.querySelectorAll('.gn-0029-video video');
    videos.forEach((video) => {
      video.muted = button.classList.contains('active');
    })
  }))

  const close = document.querySelectorAll('.gn-0029-video-close');
  close.forEach((button) => {
    button.addEventListener('click', (e) => {
      const popups = document.querySelectorAll('.gn-0029-popup');

      popups.forEach((popup) => {
        const image = popup.querySelector('.gn-0029-popup-img');
        const video = popup.querySelector('.gn-0029-video-container');
        const videos = popup.querySelectorAll('.gn-0029-video video');
        const bullets = popup.querySelectorAll('.gn-0029-bullet');
        const prev = popup.querySelector('.gn-0029-video-prev');
        const next = popup.querySelector('.gn-0029-video-next');

        //Video
        videos.forEach((video) => {
          video.pause();
          video.currentTime = 0;
          video.parentElement.classList.remove('active');
        });

        //Reset bullets
        bullets.forEach((bullet) => bullet.classList.remove('active'));
        bullets[0].classList.add('active');

        //Reset position
        videos[0].scrollIntoView();

        //Reset pagination
        prev.dataset.id = 1;
        next.dataset.id = 0;

        //Remove visibiliy
        image.classList.add('active');
        video.classList.remove('active');
      })
    })
  })

  //Intersection
  const targets = document.querySelectorAll('.gn-0029-video');
  const options = {
    rootMargin: '0px',
    threshold: window.innerWidth < 1024 ? 0.15 : 1
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      const target = entry.target;
      const parent = target.parentElement;
      const bulletParent = parent.querySelector('.gn-0029-bullets');
      const bullets = parent.querySelectorAll('.gn-0029-bullets .gn-0029-bullet');

      //Get ID
      const { id } = target.dataset;

      //Find bullet and activate it
      bullets.forEach((bullet) => bullet.classList.remove('active'))
      if(bullets[id]) {
        bullets[id].classList.add('active');
      }

      if (entry.isIntersecting) {
        target.classList.add('active');

        //Find video
        const video = target.querySelector('video');

        //Play it
        video.play();
      } else {
        target.classList.remove('active');

        //Stop all other videos
        const videos = document.querySelectorAll('.gn-0029-video video');
        videos.forEach((video) => video.pause());
      }
    })
  }, options);

  targets.forEach(target => {
    //observer.observe(target)
  })
}

const stopVideos = () => {
  const videos = document.querySelectorAll('.gn-0029-video video');
  //Video
  videos.forEach((video) => {
    video.pause();
    video.currentTime = 0;
  });
}

const close = () => {
  const overlay = document.querySelector('.gn-0029-popup-overlay');
  overlay.classList.remove('active');

  //Popups
  const popups = document.querySelectorAll('.gn-0029-popup');
  popups.forEach((popup) => popup.classList.remove('active'));

  //Remove Body
  document.body.classList.remove('active');

  //Stop Videos
  stopVideos();
}

document.addEventListener("DOMContentLoaded", async () => {
  document.body.classList.add('as-gn-0029');

  await moveVideos();

  const slidesWrapper = document.querySelector('.gn-0029-wrapper');
  setUpSlider(slidesWrapper);

  const popupsWrapper = document.querySelector('.gn-0029-popups');
  setUpPopups(slidesWrapper, popupsWrapper);

  //Bullets
  createBullets();

  //Create Video Controls
  videoControls();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geolizr-countdown"] && !Shopify.designMode) return;
  try {
    

  /**************************************************************************************
   *  Geolizr Countdown – überarbeitete Version
   *
   *  Wesentliche Änderungen:
   *  - Arbeitet intern mit Date-Objekten statt mit rohen ms-Timestamps.
   *    Die einzige Millisekunden-Rechnung steckt gekapselt in remaining().
   *  - End-Daten werden einmalig geparst und gecached
   *    (vorher: DOM-Query + JSON-Parse in jedem Tick).
   *  - Die 8-KB-JSON5-Bibliothek wurde durch einen kleinen toleranten
   *    Parser ersetzt (Single-Quotes, unquoted Keys, trailing commas).
   *  - Diverse Bugfixes (debugger, indexOf, toter Code, stale DOM-Referenzen
   *    im Editor, fehlende Plural-Defaults, doppelte start-info-Divs, ...).
   **************************************************************************************/

  /***
   * Toleranter JSON-Parser als leichter Ersatz für JSON5.
   * Versucht zuerst striktes JSON, normalisiert danach die üblichen
   * "JSON5-artigen" Merchant-Configs: 'Single-Quotes', unquoted Keys
   * und trailing commas.
   *
   * Achtung: Werte mit Apostrophen (z.B. "O'Brien") würden im Fallback
   * zerlegt – für Ländercodes und Datums-Strings ist das kein Problem.
   *
   * @param {string} text - Roh-String aus dem Section-Setting.
   * @return {object} - Geparste End-Daten.
   **************************/
  function geolizrParseLooseJson(text) {
    // Shopify rendert inzwischen HTML-Kommentare mit in den Section-Output –
    // die müssen vor dem Parsen raus, sonst: Unexpected token '<'
    const cleaned = text.replace(/<!--[\s\S]*?-->/g, '').trim();

    try {
      return JSON.parse(cleaned);
    } catch (err) {
      // Fallback unten
    }

    const normalized = cleaned
      .replace(/'/g, '"')                                     // 'DE' -> "DE"
      .replace(/,\s*([}\]])/g, '$1')                          // trailing commas entfernen
      .replace(/([{,]\s*)([A-Za-z0-9_*-]+)\s*:/g, '$1"$2":'); // unquoted Keys quoten

    return JSON.parse(normalized);
  }

  class GeolizrCountdown {
    constructor(config, countryCode) {
      this.country = (countryCode || '*').toUpperCase();
      this.active = true;
      this.init(config);
    }

    init(config) {
      this.visible = false;
      this.editor = false;
      this.config = config;

      this.rebindDom();

      // Alle konfigurierten Daten einmalig als Date-Objekte parsen
      this.reloadEndDates();
      this.activateStart = this.parseDate(config.activateStartDate);
      this.activateEnd = this.parseDate(config.activateEndDate);
      this.initPluralSingle(config.singlePluralString);

      this.checkActivation();
    }

    /***
     * Holt die DOM-Referenzen (neu). Muss nach einem shopify:section:load
     * erneut aufgerufen werden, weil die Section dann komplett neu
     * gerendert wurde und alte Referenzen ins Leere zeigen.
     *
     * @return void
     **************************/
    rebindDom() {
      this.section = document.querySelector(`#shopify-section-${this.config.section_id}`);
      this.wrapper = this.section.querySelector('.geolizr-countdown-wrapper');
      this.element = this.section.querySelector('span.timer');
    }

    /***
     * Wandelt einen Datums-String in ein Date-Objekt um.
     * "none", leere Strings und ungültige Daten ergeben null (mit Warnung
     * in der Konsole, damit Merchants Tippfehler sofort sehen).
     *
     * @param {string} value - Datums-String, z.B. "2026-12-24T18:00:00".
     * @return {Date|null}
     **************************/
    parseDate(value) {
      if (!value || value === 'none') return null;
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        console.warn(`Geolizr countdown: ungültiges Datum "${value}" – wird ignoriert`);
        return null;
      }
      return date;
    }

    /***
     * Liest die End-Daten aus dem DOM, parst sie EINMAL und cached das
     * Ergebnis. Ermittelt das für das aktuelle Land gültige Enddatum
     * (Fallback: "*") als Date-Objekt.
     *
     * @return void
     **************************/
    reloadEndDates() {
      const el = this.section.querySelector('.countdown-endDates');
      this.config.endDates = geolizrParseLooseJson(el.innerHTML);

      let value = this.config.endDates['*'];
      this.usedCountry = '*';
      if (typeof this.config.endDates[this.country] !== 'undefined') {
        value = this.config.endDates[this.country];
        this.usedCountry = this.country;
      }

      // Date-Objekt statt Timestamp – z.B. this.endDate.toLocaleString()
      // liefert jederzeit ein menschenlesbares Datum fürs Debugging.
      this.endDate = this.parseDate(value);
    }

    /***
     * Liest die aktuellen Section-Einstellungen aus dem DOM neu ein.
     *
     * Wichtig für den Theme-Editor: Nach shopify:section:load wird das
     * Inline-<script> mit window.geolizrCountdownConfig NICHT erneut
     * ausgeführt – die Config der Instanz wäre also stale. Deshalb liegen
     * alle live änderbaren Settings zusätzlich als data-Attribute am
     * countdown-config-Template und werden hier frisch übernommen.
     *
     * @return void
     **************************/
    reloadSettings() {
      const configElement = this.section.querySelector('.countdown-config');
      if (!configElement) return;

      const data = configElement.dataset;
      this.active = data.active === 'true';
      this.config.expiredHide = data.expiredHide === 'true';
      this.activateStart = this.parseDate(data.activateStart);
      this.activateEnd = this.parseDate(data.activateEnd);
      this.initPluralSingle(data.singlePlural);
    }

    /***
     * Berechnet die Restzeit bis zum Enddatum als lesbares Objekt.
     * Dies ist die EINZIGE Stelle im Code, an der mit Millisekunden
     * gerechnet wird – der Rest des Codes spricht in Tagen/Stunden/etc.
     *
     * @param {Date} [now] - Referenzzeitpunkt (Default: jetzt).
     * @return {object} { expired, days, hours, fullHours, minutes, fullMinutes, seconds }
     **************************/
    remaining(now = new Date()) {
      if (!this.endDate) {
        return { expired: true, days: 0, hours: 0, fullHours: 0, minutes: 0, fullMinutes: 0, seconds: 0 };
      }

      const msLeft = this.endDate.getTime() - now.getTime();
      const totalSeconds = Math.max(0, Math.floor(msLeft / 1000));

      const seconds = totalSeconds % 60;
      const fullMinutes = Math.floor(totalSeconds / 60);
      const minutes = fullMinutes % 60;
      const fullHours = Math.floor(fullMinutes / 60);
      const hours = fullHours % 24;
      const days = Math.floor(fullHours / 24);

      return { expired: msLeft <= 0, days, hours, fullHours, minutes, fullMinutes, seconds };
    }

    /***
     * Baut aus der Restzeit die Variablen für die Template-Verarbeitung.
     *
     * @param {object} r - Ergebnis von remaining().
     * @return {object} - Variablen für parseTemplate().
     **************************/
    buildVariables(r) {
      return {
        days: r.days,
        hours: r.hours,
        fullHours: r.fullHours,
        fullMinutes: r.fullMinutes,
        minutes: r.minutes,
        seconds: r.seconds,
        dayString: r.days,
        hourString: r.fullHours,
        minuteString: r.minutes,
        secondString: r.seconds,
        countdown: r.seconds
      };
    }

    /***
     * Parst die Singular/Plural-Strings aus dem Section-Setting.
     * Es gibt jetzt Defaults, damit ein leeres oder unvollständiges
     * Setting keinen TypeError mehr im Countdown-Parser auslöst.
     *
     * @param {string} singlePluralStrings - z.B. "days/day,hours/hour,..."
     * @return void
     **************************/
    initPluralSingle(singlePluralStrings) {
      this.pluralSingle = {
        d: { plural: 'days', singular: 'day' },
        H: { plural: 'hours', singular: 'hour' },
        m: { plural: 'minutes', singular: 'minute' },
        s: { plural: 'seconds', singular: 'second' }
      };

      if (!singlePluralStrings) return;

      const textIndex = ['d', 'H', 'm', 's'];
      singlePluralStrings.split(',').forEach((pair, index) => {
        const [plural, singular] = pair.split('/').map((value) => value.trim());
        if (plural && singular && typeof textIndex[index] !== 'undefined') {
          this.pluralSingle[textIndex[index]] = { plural, singular };
        }
      });
    }

    /***
     * Zeigt den Countdown an und ergänzt im Editor einen Hinweis mit dem
     * (menschenlesbaren) Startdatum. Legt das Hinweis-Div nur einmal an.
     *
     * @return void
     **************************/
    showWithStart() {
      this.show();
      if (this.wrapper.querySelector('.start-info')) return; // keine Duplikate im Editor

      const info = document.createElement('div');
      info.classList.add('start-info');
      info.textContent = 'show: ' + (this.activateStart
        ? this.activateStart.toLocaleString()
        : this.config.activateStartDate);
      this.wrapper.appendChild(info);
    }

    /***
     * Zeigt den Countdown an.
     *
     * @return void
     **************************/
    show() {
      this.visible = true;
      this.wrapper.style.display = 'block';
    }

    /***
     * Versteckt den Countdown inkl. der Section selbst, damit bei
     * expired_hide kein leerer (ggf. eingefärbter) Balken stehen bleibt.
     *
     * @return void
     **************************/
    hide() {
      this.visible = false;
      this.wrapper.style.display = 'none';
      if (this.section) {
        this.section.classList.remove('show');
      }
    }

    /***
     * Prüft, ob der Countdown wegen Ablauf ausgeblendet werden soll.
     * Nur relevant, wenn expiredHide aktiv ist. Berücksichtigt, ob das
     * Template überhaupt eine Variable nutzt, die noch > 0 ist.
     *
     * @param {Date} [now] - Referenzzeitpunkt.
     * @return {boolean} - true, wenn der Countdown ausgeblendet werden soll.
     **************************/
    shouldHideWhenExpired(now = new Date()) {
      if (this.config.expiredHide !== true) return false;

      const r = this.remaining(now);
      if (r.expired) return true;

      const template = this.getTimerText();

      // Der {countdown | elements: ...}-Platzhalter liefert bis zur letzten
      // Sekunde sinnvolle Ausgaben – solange nicht abgelaufen, nie ausblenden.
      // (Fix: vorher indexOf(...) > 0, was bei Position 0 fehlschlug.)
      if (template.indexOf('{countdown') !== -1) return false;

      // Nur ausblenden, wenn keine im Template genutzte Variable > 0 ist
      const variables = this.buildVariables(r);
      const isRelevant = Object.keys(variables).some(
        (key) => template.includes(`{${key}`) && variables[key] > 0
      );

      return !isRelevant;
    }

    /***
     * Prüft Start-/Enddatum der Aktivierung und steuert die Anzeige.
     * Die Daten liegen hier bereits als Date-Objekte vor und lassen sich
     * direkt vergleichen (activateStart <= now).
     *
     * @return void
     **************************/
    checkActivation() {
      const now = new Date();

      if (this.shouldHideWhenExpired(now)) {
        clearInterval(this.timer);
        this.visible = false;
        this.active = false;
        return;
      }

      // Ohne (gültiges) Startdatum sofort anzeigen – ungültige Daten wurden
      // in parseDate() bereits mit Warnung auf null gesetzt.
      if (!this.activateStart || this.activateStart <= now) {
        this.show();
      } else if (window.Shopify && Shopify.designMode) {
        this.showWithStart(); // Editor: Hinweis mit lesbarem Startdatum
      }

      // Aktivierungs-Enddatum erreicht -> ausblenden
      if (this.activateEnd && this.activateEnd <= now) {
        this.hide();
      }
    }

    /***
     * Rendert den gegebenen HTML-Text in das Timer-Element und macht die
     * Section sichtbar.
     *
     * @param {string} htmlText
     * @return void
     **************************/
    render(htmlText) {
      this.element.innerHTML = htmlText;
      if (this.section) {
        this.section.classList.add('show');
      }
    }

    /***
     * Liefert die Timer-Textvorlage aus dem DOM.
     *
     * @return {string}
     **************************/
    getTimerText() {
      return this.section.querySelector('.countdown-timerText').innerHTML;
    }

    /***
     * Liefert den Expired-Text – live aus dem DOM-Template, damit
     * Änderungen im Theme-Editor sofort greifen (Config-Fallback für
     * ältere Setups ohne das Template).
     *
     * @return {string}
     **************************/
    getExpiredText() {
      const el = this.section.querySelector('.countdown-expiredText');
      return el ? el.innerHTML : this.config.expired;
    }

    /***
     * Liefert Parser-Objekte für die Template-Verarbeitung
     * (Singular/Plural-Platzhalter und {countdown | elements: ...}).
     *
     * @return {object}
     **************************/
    getParserObjects() {
      return {
        parseStrings: {
          // {key | singular: "X" | plural: "Y"}
          regex: /\{(\w+)\s*\|\s*singular:\s*["'](.*?)["']\s*\|\s*plural:\s*["'](.*?)["']\s*\}/g,
          callback: (args, variables) => {
            const [, key, singular, plural] = args;
            const value = variables[key];
            if (typeof value === 'undefined') return '';
            const valCount = Number(value);
            return `${valCount} ${valCount === 1 ? singular : plural}`;
          }
        },
        countdown: {
          // {countdown | elements: "X,Y,Z"}
          regex: /\{countdown\s*\|\s*elements:\s*["'](.*?)["']\s*\}/g,
          callback: (args, variables) => {
            const [, elements] = args;
            const elementList = elements.split(',').map((e) => e.trim());

            const wants = (name, short) => elementList.includes(name) || elementList.includes(short);

            // Kaskade von der größten zur kleinsten angeforderten Einheit.
            // Bewusst OHNE obere Grenzen: Ist eine größere Einheit nicht im
            // Template angefordert (z.B. "hours,minutes,seconds" ohne days),
            // fängt die nächstkleinere Einheit den Zeitraum mit ihrem
            // full*-Wert ab, statt in den "0 seconds"-Fallback zu laufen.
            if (wants('days', 'd') && variables.fullHours >= 48) {
              return `${variables.days} ${this.pluralSingle.d.plural}`;
            }
            if (wants('hours', 'H') && variables.fullHours >= 2) {
              return `${variables.fullHours} ${this.pluralSingle.H.plural}`;
            }
            if (wants('minutes', 'm') && variables.fullMinutes >= 1) {
              const minuteText = Number(variables.fullMinutes) === 1 ? this.pluralSingle.m.singular : this.pluralSingle.m.plural;
              return `${variables.fullMinutes} ${minuteText}`;
            }
            if (wants('seconds', 's')) {
              const secondText = Number(variables.seconds) === 1 ? this.pluralSingle.s.singular : this.pluralSingle.s.plural;
              return `${variables.seconds} ${secondText}`;
            }

            return '0 ' + this.pluralSingle.s.plural; // Fallback
          }
        }
      };
    }

    /***
     * Ersetzt Platzhalter in einer Vorlage durch die Variablenwerte und
     * wendet die spezifischen Parser an.
     *
     * @param {string} template
     * @param {object} variables
     * @return {string}
     **************************/
    parseTemplate(template, variables) {
      const parsers = this.getParserObjects();

      // ${key} durch Variablenwerte ersetzen
      let result = template.replace(/\$\{(\w+)\}/g, (_, key) => {
        return Object.prototype.hasOwnProperty.call(variables, key)
          ? variables[key]
          : '';
      });

      // Spezifische Parser anwenden
      for (const parserKey in parsers) {
        const parser = parsers[parserKey];
        result = result.replace(parser.regex, (...args) => parser.callback(args, variables));
      }

      return result;
    }

    /***
     * Aktualisiert den Countdown. Nach Ablauf wird das Intervall gestoppt:
     * Bei expiredHide wird ausgeblendet, andernfalls bleibt der
     * Expired-Text einfach stehen (kein Grund, weiter sekündlich zu rendern).
     *
     * @return void
     **************************/
    tick() {
      if (this.active === false) {
        this.hide();
        clearInterval(this.timer); // wird bei Reaktivierung via execute() neu gestartet
        return;
      }
      this.show();

      const r = this.remaining();
      let template;
      let variables = {};

      if (!r.expired) {
        variables = this.buildVariables(r);
        template = this.getTimerText();
      } else {
        template = this.getExpiredText();
      }

      this.render(this.parseTemplate(template, variables));

      if (r.expired) {
        clearInterval(this.timer);
        if (this.config.expiredHide === true) {
          this.hide();
          this.active = false;
        }
      }
    }

    /***
     * Startet den Countdown und aktualisiert ihn jede Sekunde.
     * Ein evtl. laufendes Intervall wird vorher gestoppt (Editor-Reloads).
     *
     * @return void
     **************************/
    execute() {
      clearInterval(this.timer);
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
  }

  document.addEventListener('geolizr.init', () => {
    const config = window.geolizrCountdownConfig;
    if (!config) return; // Section deaktiviert

    if (typeof Geolizr.countdown !== 'undefined') {
      const err = 'double defined in ' + Geolizr.countdown.config.section_id;
      // Fix: vorher wurde die nicht existierende Methode countdown.error()
      // aufgerufen – gemeint war Geolizr.CountDownError.
      if (Geolizr.countdown.editor === true && typeof Geolizr.CountDownError === 'function') {
        Geolizr.CountDownError('Geolizr error: ' + err);
      }
      console.error('Geolizr error:', err);
      return;
    }

    /**************************************************************************************
     *  CONFIG and init countdown
     **************************************************************************************/
    try {
      Geolizr.CountDownError = function (message) {
        document.querySelectorAll('.geolizr-countdown-error').forEach((el) => {
          const div = document.createElement('div');
          div.innerHTML = message;
          el.appendChild(div);
          el.parentElement.classList.add('show');
        });
        const wrapper = document.querySelector(`#shopify-section-${config.section_id} .geolizr-countdown-wrapper`);
        if (wrapper) wrapper.style.display = 'block';
      };

      const cachedCountry = sessionStorage.getItem('geolizr-cachedData');

      if (cachedCountry) {
        Geolizr.countdown = new GeolizrCountdown(config, cachedCountry);
        Geolizr.countdown.execute();
      } else if (window.Shopify && Shopify.designMode) {
        Geolizr.countdown = new GeolizrCountdown(config, window.editor_test_country);
        Geolizr.countdown.editor = true;
        Geolizr.countdown.active = window.countdownEnable === true;
        Geolizr.countdown.execute();

        document.addEventListener('shopify:section:load', (e) => {
          // Fix: dynamische Section-ID statt hartem "geolizr-countdown"-Vergleich
          if (e.detail.sectionId !== Geolizr.countdown.config.section_id) return;

          const cd = Geolizr.countdown;
          cd.rebindDom();       // Section wurde neu gerendert -> Referenzen erneuern
          cd.reloadEndDates();  // geänderte End-Daten übernehmen
          cd.reloadSettings();  // expired_hide, Aktivierungs-Daten, Plural-Strings etc.

          if (cd.active) {
            cd.checkActivation(); // Sichtbarkeit nach aktuellem Stand neu bewerten
          } else {
            cd.hide();
          }
          cd.execute();
        });
      } else if (typeof Geolizr !== 'undefined') {
        Geolizr.getGeoData((data) => {
          sessionStorage.setItem('geolizr-cachedData', data.country.code);
          Geolizr.countdown = new GeolizrCountdown(config, data.country.code);
          Geolizr.countdown.execute();
        });
      }
    } catch (err) {
      if (window.Shopify && Shopify.designMode === true) {
        Geolizr.CountDownError('Geolizr error: ' + err.message);
      }
      console.error('Geolizr error:', err);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
